export default __webpack_public_path__ + "static/media/sourcelocal.b64c21ef.jpg";